import { render, staticRenderFns } from "./textbox.vue?vue&type=template&id=368c4fa9"
import script from "./textbox.vue?vue&type=script&lang=js"
export * from "./textbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports